import config from './../config'

const { API_URL, MERCURE_HUB_URL } = config.env

export default class MercureListener {
  constructor (subscribeTo, onReceiveMessage) {
    this.eventSource = null
    this.onReceiveMessage = null

    this.onReceiveMessage = onReceiveMessage
    this.setData(subscribeTo)
  }

  setData (subscribeTo) {
    let data = []
    // if subscribeTo is api endpoint
    if (typeof subscribeTo === 'string') {
      data.push({
        '@id': subscribeTo
      })
      // if subscribeTo is api response
    } else {
      data = subscribeTo['hydra:member']
    }
    this.eventSource && this.eventSource.close()
    if (data.length > 0) {
      this.setupEventSource(data)
    }
  }

  setupEventSource (data) {
    if (!API_URL || !MERCURE_HUB_URL) {
      throw new Error('Failed te setup `mercure` listener')
    }

    data.forEach((item) => {
      MERCURE_HUB_URL.searchParams.append('topic', `${API_URL.replace('/api/', '')}${item['@id']}`)
    })

    this.eventSource = new EventSource(MERCURE_HUB_URL.toString())
    this.eventSource.onmessage = this.onReceiveMessage
  }
}
